const SvgOperations1 = (props) => (
  <>
    <path fill={props.p20} d="M144.1 48.02V16H16v128.36h31.93V48.02h96.17z" />
    <path fill={props.p30} d="M47.9 143.98V176H176V47.64h-31.93v96.34H47.9z" />
    <circle cx={63.59} cy={63.84} r={1} fill="#021d6c" />
    <circle cx={79.59} cy={63.84} r={1} fill="#021d6c" />
    <circle cx={95.59} cy={63.84} r={1} fill="#021d6c" />
    <circle cx={111.59} cy={63.84} r={1} fill="#021d6c" />
    <circle cx={127.59} cy={63.84} r={1} fill="#021d6c" />
    <circle cx={63.59} cy={79.84} r={1} fill="#021d6c" />
    <circle cx={79.59} cy={79.84} r={1} fill="#021d6c" />
    <circle cx={95.59} cy={79.84} r={1} fill="#021d6c" />
    <circle cx={111.59} cy={79.84} r={1} fill="#021d6c" />
    <circle cx={127.59} cy={79.84} r={1} fill="#021d6c" />
    <circle cx={63.59} cy={95.84} r={1} fill="#021d6c" />
    <circle cx={79.59} cy={95.84} r={1} fill="#021d6c" />
    <circle cx={95.59} cy={95.84} r={1} fill="#021d6c" />
    <circle cx={111.59} cy={95.84} r={1} fill="#021d6c" />
    <circle cx={127.59} cy={95.84} r={1} fill="#021d6c" />
    <circle cx={63.59} cy={111.84} r={1} fill="#021d6c" />
    <circle cx={79.59} cy={111.84} r={1} fill="#021d6c" />
    <circle cx={95.59} cy={111.84} r={1} fill="#021d6c" />
    <circle cx={111.59} cy={111.84} r={1} fill="#021d6c" />
    <circle cx={127.59} cy={111.84} r={1} fill="#021d6c" />
    <circle cx={63.59} cy={127.84} r={1} fill="#021d6c" />
    <circle cx={79.59} cy={127.84} r={1} fill="#021d6c" />
    <circle cx={95.59} cy={127.84} r={1} fill="#021d6c" />
    <circle cx={111.59} cy={127.84} r={1} fill="#021d6c" />
    <circle cx={127.59} cy={127.84} r={1} fill="#021d6c" />
  </>
);

export default SvgOperations1;
